// extracted by mini-css-extract-plugin
export default {"homeWrapper":"Home_homeWrapper__6Zy0M","title":"Home_title__L087v"};